<template>
  <div class="dashboard">
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          :key="item.text"
          v-for="item in tabs"
          class="StatementOnAccountItem"
          :class="{ active: selectedTabLabel === item.value }"
          @click="storeLabelTabName(item.text)"
        >
          {{ item.text }} <br />
        </label>
      </div>
    </div>
    <div v-if="selectedTabLabel === 'Gerais'" class="reports-wrapper">
      <div class="page-header">
        <h2 class="main-title">Relatórios Gerenciais</h2>
      </div>

      <div class="reports-container">
        <div class="report-section">
          <div class="section-header">
            <b-icon-cash class="section-icon color-vendas"></b-icon-cash>
            <span class="section-title">Vendas</span>
          </div>
          <div class="cards-grid">
            <button
              v-b-modal.modal-venda
              @click="handleType"
              class="report-card"
              name="Pedido"
            >
              <div class="icon-wrapper"><b-icon-handbag></b-icon-handbag></div>
              <div class="card-content">
                <span class="card-title">Vendas Simples</span>
                <span class="card-description"
                  >Análise simplificada de pedidos de vendas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-venda
              @click="handleType"
              class="report-card"
              name="Receita Pedido"
            >
              <div class="icon-wrapper"><b-icon-cart4></b-icon-cart4></div>
              <div class="card-content">
                <span class="card-title">Vendas Completa</span>
                <span class="card-description"
                  >Análise detalhada de faturamento e vendas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-venda
              @click="handleType"
              class="report-card"
              name="PDV"
            >
              <div class="icon-wrapper"><b-icon-cash></b-icon-cash></div>
              <div class="card-content">
                <span class="card-title">PDV</span>
                <span class="card-description"
                  >Movimentações do ponto de venda.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-venda
              @click="handleType"
              class="report-card"
              name=""
            >
              <div class="icon-wrapper">
                <b-icon-cash-stack></b-icon-cash-stack>
              </div>
              <div class="card-content">
                <span class="card-title">Todas as Vendas</span>
                <span class="card-description"
                  >Visão consolidada de todas as vendas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>

        <div class="report-section">
          <div class="section-header">
            <b-icon-calculator
              class="section-icon color-financeiro"
            ></b-icon-calculator>
            <span class="section-title">Financeiro</span>
          </div>
          <div class="cards-grid">
            <button
              v-b-modal.modal-center2
              @click="handleType"
              class="report-card"
              name="entrada"
            >
              <div class="icon-wrapper">
                <b-icon-graph-up></b-icon-graph-up>
              </div>
              <div class="card-content">
                <span class="card-title">Contas a Receber</span>
                <span class="card-description"
                  >Controle de recebimentos futuros e ativos.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center2
              @click="handleType"
              class="report-card"
              name="saida"
            >
              <div class="icon-wrapper">
                <b-icon-graph-down></b-icon-graph-down>
              </div>
              <div class="card-content">
                <span class="card-title">Contas a Pagar</span>
                <span class="card-description"
                  >Controle de pagamentos e obrigações a realizar.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center2
              @click="handleType"
              class="report-card"
              name=""
            >
              <div class="icon-wrapper">
                <b-icon-calculator></b-icon-calculator>
              </div>
              <div class="card-content">
                <span class="card-title">Contas Gerais</span>
                <span class="card-description"
                  >Resumo analítico das contas financeiras.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button v-b-modal.modal-center5 class="report-card" name="caixa">
              <div class="icon-wrapper">
                <b-icon-bank></b-icon-bank>
              </div>
              <div class="card-content">
                <span class="card-title">Caixa Geral</span>
                <span class="card-description"
                  >Movimentações diárias do fluxo de caixa.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>

        <div class="report-section">
          <div class="section-header">
            <b-icon-receipt class="section-icon color-fiscal"></b-icon-receipt>
            <span class="section-title">Emissão fiscal</span>
          </div>
          <div class="cards-grid">
            <button
              v-b-modal.modal-center1
              @click="handleType"
              class="report-card"
              name="1"
            >
              <div class="icon-wrapper"><b-icon-receipt></b-icon-receipt></div>
              <div class="card-content">
                <span class="card-title">NF-e</span>
                <span class="card-description"
                  >Notas fiscais eletrônicas de produtos.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center1
              @click="handleType"
              class="report-card"
              name="2"
            >
              <div class="icon-wrapper"><b-icon-receipt></b-icon-receipt></div>
              <div class="card-content">
                <span class="card-title">NFC-e</span>
                <span class="card-description"
                  >Notas fiscais de consumidor eletrônicas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center1
              @click="handleType"
              class="report-card"
              name="mdfe"
            >
              <div class="icon-wrapper"><b-icon-receipt></b-icon-receipt></div>
              <div class="card-content">
                <span class="card-title">MDF-e</span>
                <span class="card-description"
                  >Manifesto eletrônico de documentos fiscais.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center1
              @click="handleType"
              class="report-card"
              name=""
            >
              <div class="icon-wrapper"><b-icon-receipt></b-icon-receipt></div>
              <div class="card-content">
                <span class="card-title">Todas as Emissões</span>
                <span class="card-description"
                  >Histórico consolidado de todas as emissões.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>

        <div class="report-section">
          <div class="section-header">
            <b-icon-people class="section-icon color-cadastros"></b-icon-people>
            <span class="section-title">Cadastros</span>
          </div>
          <div class="cards-grid">
            <button
              v-b-modal.modal-clientes
              @click="handleType"
              class="report-card"
              name="Clientes"
            >
              <div class="icon-wrapper"><b-icon-person></b-icon-person></div>
              <div class="card-content">
                <span class="card-title">Clientes</span>
                <span class="card-description"
                  >Listagem, cadastros e relatórios de clientes.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-colaboradores
              @click="handleType"
              class="report-card"
              name="Colaborador"
            >
              <div class="icon-wrapper"><b-icon-people></b-icon-people></div>
              <div class="card-content">
                <span class="card-title">Funcionários</span>
                <span class="card-description"
                  >Informações e cadastros de colaboradores.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center6
              @click="handleType"
              class="report-card"
              name="Produtos"
            >
              <div class="icon-wrapper"><b-icon-box></b-icon-box></div>
              <div class="card-content">
                <span class="card-title">Produtos</span>
                <span class="card-description"
                  >Listagem e especificações de produtos.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-fornecedores
              class="report-card"
              name="Fornecedores"
            >
              <div class="icon-wrapper"><b-icon-truck></b-icon-truck></div>
              <div class="card-content">
                <span class="card-title">Fornecedores</span>
                <span class="card-description"
                  >Cadastro e dados de fornecedores parceiros.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>

        <div class="report-section">
          <div class="section-header">
            <b-icon-paperclip
              class="section-icon color-outros"
            ></b-icon-paperclip>
            <span class="section-title">Outros</span>
          </div>
          <div class="cards-grid">
            <button
              v-b-modal.modal-receiptiti
              @click="handleType"
              class="report-card"
              name="receita"
            >
              <div class="icon-wrapper">
                <b-icon-journal-text></b-icon-journal-text>
              </div>
              <div class="card-content">
                <span class="card-title">Receitas</span>
                <span class="card-description"
                  >Relatórios adicionais de receitas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-center4
              @click="handleType"
              class="report-card"
              name="compras"
            >
              <div class="icon-wrapper">
                <b-icon-cart-plus></b-icon-cart-plus>
              </div>
              <div class="card-content">
                <span class="card-title">Compras</span>
                <span class="card-description"
                  >Relatórios de ordens de compra e aquisições.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-movStock
              @click="handleType"
              class="report-card"
              name="servico"
            >
              <div class="icon-wrapper">
                <b-icon-arrow-left-right></b-icon-arrow-left-right>
              </div>
              <div class="card-content">
                <span class="card-title">Movimentações Estoque</span>
                <span class="card-description"
                  >Entradas, saídas e saldos de inventário.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button v-b-modal.modal-product-movement class="report-card">
              <div class="icon-wrapper">
                <b-icon-journal-text></b-icon-journal-text>
              </div>
              <div class="card-content">
                <span class="card-title"
                  >Relação de Movimentação de Produto</span
                >
                <span class="card-description"
                  >Resumo e detalhamento por produto e embalagem.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              v-b-modal.modal-dashboard
              @click="handleType"
              class="report-card"
              name="dashboard"
            >
              <div class="icon-wrapper">
                <b-icon-graph-up></b-icon-graph-up>
              </div>
              <div class="card-content">
                <span class="card-title">Dashboard</span>
                <span class="card-description"
                  >Visão gerencial geral e indicadores.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="selectedTabLabel === 'Relatórios Regulatórios'"
      class="reports-wrapper"
    >
      <div class="page-header">
        <h2 class="main-title">Relatórios Regulatórios</h2>
      </div>
      <div class="reports-container">
        <div class="report-section">
          <div class="section-header">
            <b-icon-list-ul class="section-icon color-vendas"></b-icon-list-ul>
            <span class="section-title">Outros</span>
          </div>
          <div class="cards-grid">
            <button
              @click="handleOpenModalCreaCfta('cfta')"
              class="report-card"
            >
              <div class="icon-wrapper">
                <b-icon-journal-text></b-icon-journal-text>
              </div>
              <div class="card-content">
                <span class="card-title">CFTA</span>
                <span class="card-description"
                  >Conselho Federal dos Técnicos Agrícolas.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>

            <button
              @click="handleOpenModalCreaCfta('crea')"
              class="report-card"
            >
              <div class="icon-wrapper">
                <b-icon-journal-check></b-icon-journal-check>
              </div>
              <div class="card-content">
                <span class="card-title">CREA</span>
                <span class="card-description"
                  >Conselho Regional de Engenharia e Agronomia.</span
                >
              </div>
              <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
            </button>
          </div>
        </div>
      </div>
      <div class="report-section" style="margin-top: 10px">
        <div class="section-header">
          <b-icon-geo-alt
            class="section-icon color-financeiro"
          ></b-icon-geo-alt>
          <span class="section-title">Por Estado</span>
        </div>

        <div class="cards-grid">
          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Acre" alt="AC" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Acre (IDAF-AC)</span>
              <span class="card-description"
                >Instituto de Defesa Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Alagoas" alt="AL" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Alagoas (SIARE)</span>
              <span class="card-description"
                >Sistema Integrado de Administração de Receitas.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Amapa" alt="AP" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Amapá (DIAGRO)</span>
              <span class="card-description"
                >Agência de Defesa e Inspeção Agropecuária do Estado do
                Amapá.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Amazonas" alt="AM" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Amazonas (ADAF)</span>
              <span class="card-description"
                >Agência de Defesa Agropecuária e Florestal do Estado do
                Amazonas.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button
            v-b-modal.modal-adab
            class="report-card"
            :disabled="adabStatus === 'Report ADAB is processing'"
            style="position: relative; overflow: hidden"
          >
            <div class="icon-wrapper image-icon">
              <img :src="Bahia" alt="BA" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Bahia (ADAB)</span>
              <span class="card-description"
                >Agência de Defesa Agropecuária da Bahia.</span
              >
            </div>

            <div
              v-if="adabStatus === 'Report ADAB is processed'"
              class="download-badge"
              @click.stop="downloadAdab"
            >
              <b-icon-cloud-download-fill></b-icon-cloud-download-fill>
            </div>
            <b-icon-chevron-right
              v-else
              class="card-arrow"
            ></b-icon-chevron-right>

            <div
              v-if="adabStatus === 'Report ADAB is processing'"
              class="card-processing-overlay"
            >
              <b-spinner small variant="light"></b-spinner>
            </div>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Ceara" alt="CE" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Ceára (SIDAGRO)</span>
              <span class="card-description"
                >Sistema de Defesa Agropecuária do Estado do Ceará.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Espirito" alt="ES" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Espírito Santo (IDAF)</span>
              <span class="card-description"
                >Instituto de Defesa Agropecuária e Florestal do Espírito
                Santo.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Goias" alt="GO" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Goiás (SIDAGO)</span>
              <span class="card-description"
                >Sistema de Defesa Agropecuária de Goiás.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Maranhao" alt="MA" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Maranhão (SIGAMA)</span>
              <span class="card-description"
                >Sistema de Gestão Agropecuária do Maranhão.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="MatoGrosso"
                alt="MT"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title">Mato Grosso (INDEA)</span>
              <span class="card-description"
                >Instituto de Defesa Agropecuária do Estado de Mato
                Grosso.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="MatoGrosso"
                alt="MS"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title">Mato Grosso Sul (IAGRO)</span>
              <span class="card-description"
                >Agência Estadual de Defesa Sanitária Animal e Vegetal.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button
            v-b-modal.modal-sicca
            class="report-card"
            :disabled="siccaStatus === 'Sicca is processing'"
            style="position: relative; overflow: hidden"
          >
            <div class="icon-wrapper image-icon">
              <img :src="Minas" alt="MG" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">Minas Gerais (SICCA)</span>
              <span class="card-description"
                >Sistema de Informações de Agrotóxicos.</span
              >
            </div>

            <div
              v-if="siccaStatus === 'Sicca is processed'"
              class="download-badge"
              @click.stop="downloadSicca"
            >
              <b-icon-cloud-download-fill></b-icon-cloud-download-fill>
            </div>
            <b-icon-chevron-right
              v-else
              class="card-arrow"
            ></b-icon-chevron-right>

            <div
              v-if="siccaStatus === 'Sicca is processing'"
              class="card-processing-overlay"
            >
              <b-spinner small variant="light"></b-spinner>
            </div>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Para" alt="PA" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Pará (SIGEAGRO)</span>
              <span class="card-description"
                >Sistema de Gestão Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-siagro class="report-card">
            <div class="icon-wrapper image-icon">
              <img :src="Parana" alt="PR" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Paraná (SIAGRO)</span>
              <span class="card-description"
                >Sistema de Gestão Agropecuária.</span
              >
            </div>
            <div
              v-if="siagroStatus === 'Siagro is processed'"
              class="download-badge"
              @click.stop="downloadSiagro"
            >
              <b-icon-cloud-download-fill></b-icon-cloud-download-fill>
            </div>
            <b-icon-chevron-right
              v-else
              class="card-arrow"
            ></b-icon-chevron-right>

            <div
              v-if="siagroStatus === 'Siagro is processing'"
              class="card-processing-overlay"
            >
              <b-spinner small variant="light"></b-spinner>
            </div>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Paraiba" alt="PB" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Paraíba (SIDAP)</span>
              <span class="card-description"
                >Sistema de Defesa Agropecuária da Paraíba.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="Pernambuco"
                alt="PE"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title"> Pernambuco (SIAP)</span>
              <span class="card-description"
                >Sistema de Integração Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Piaui" alt="PI" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Piauí (SIDAPI)</span>
              <span class="card-description">
                Sistema de Defesa Agropecuária do Piauí.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Rio" alt="RJ" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Rio de Janeiro (SIAPEC)</span>
              <span class="card-description">
                Sistema de Integração Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="RioGrandeNorte"
                alt="RN"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title"> Rio Grande do Norte (SIAPEC)</span>
              <span class="card-description">
                Sistema de Integração Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="RioGrandeSul"
                alt="RS"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title"> Rio Grande do Sul (SIG@)</span>
              <span class="card-description">
                Sistema Integrado de Gestão de Agrotóxicos.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Rondonia" alt="RO" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Rondônia (IDARON)</span>
              <span class="card-description">
                Agência de Defesa Sanitária Agrosilvopastoril.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Roraima" alt="RR" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Roraima (ADERR)</span>
              <span class="card-description">
                Agência de Defesa Agropecuária do Estado de Roraima.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="SantaCatarina"
                alt="SC"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title"> Santa Catarina (SIGEN)</span>
              <span class="card-description"
                >Sistema de Gestão da Defesa Agropecuária Catarinense.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="SaoPaulo" alt="SP" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title">São Paulo (GEDAVE)</span>
              <span class="card-description"
                >Gestão de Defesa Vegetal e Animal.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img :src="Sergipe" alt="SE" style="width: 50px; height: 35px" />
            </div>
            <div class="card-content">
              <span class="card-title"> Sergipe (EMDAGRO)</span>
              <span class="card-description"
                >Empresa de Desenvolvimento Agropecuário de Sergipe.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>

          <button v-b-modal.modal-center class="report-card" disabled>
            <div class="icon-wrapper image-icon">
              <img
                :src="Tocantins"
                alt="TO"
                style="width: 50px; height: 35px"
              />
            </div>
            <div class="card-content">
              <span class="card-title"> Tocantins (ADAPEC)</span>
              <span class="card-description"
                >Agência de Defesa Agropecuária.</span
              >
            </div>
            <b-icon-chevron-right class="card-arrow"></b-icon-chevron-right>
          </button>
        </div>
      </div>

      <div class="info-footer mt-4">
        <b-icon-info-circle class="mr-2"></b-icon-info-circle>
        <span
          >Os relatórios são atualizados conforme as exigências de cada órgão
          regulador.</span
        >
      </div>
    </div>

    <div v-if="selectedTabLabel === 'Contábeis'">
      <div class="mt-4">
        <ReportsAccounting />
      </div>
    </div>

    <b-modal id="modal-receiptiti" size="lg" hide-footer hide-header centered>
      <div
        class="containerModal"
        style="
          justify-content: flex-start;
          min-height: auto !important;
          gap: 15px;
        "
      >
        <h6 class="titleModal">Relátorio de Receitas</h6>

        <div class="rowContainer" style="margin: 0 !important">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
              <div class="containerRadio">
                <label>
                  <input type="checkbox" v-model="finishing" />
                  <span>Finalizadas</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer" style="margin: 0 !important">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 40%"
              class="borderInput shadow-none"
              :options="[
                { value: '', text: 'Geral' },
                { value: 'Por ART/TRT', text: 'Por ART/TRT' },
                { value: 'Receitas por cliente', text: 'Receitas por cliente' },
                { value: 'Produtos da Receita', text: 'Produtos da Receita' },
                { value: 'Receitas Diarias', text: 'Receitas Diarias' },
                { value: 'Estorno de Embalagem', text: 'Estorno de Embalagem' },
              ]"
              v-model="selectedLabel"
            >
            </b-form-select>
            <div
              class="input-group"
              v-if="this.selectedLabel === 'Por ART/TRT'"
            >
              <input
                style="width: 211px"
                type="text"
                class="input borderInput"
                v-model="artTrt"
              />
              <label class="user-label"> ART/TRT </label>
            </div>
            <div
              class="selectPlus"
              v-if="this.selectedLabel === 'Receitas por cliente'"
            >
              <label class="fixedSelect2">Selecione o Cliente:</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="id"
                text-field="nome"
                :options="dataCustomers"
                v-model="idCliente"
              >
              </b-form-select>
            </div>
          </div>
        </div>
        <div
          class="rowContainer"
          style="margin: 0 !important"
          v-if="
            this.selectedLabel === 'Por ART/TRT' ||
            this.selectedLabel === 'Produtos da Receita'
          "
        ></div>
        <div class="rowContainer" style="margin: 0 !important" v-else>
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione as
            colunas</span
          >
          <div class="rowContent">
            <div
              class="containerRadioReceipt"
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumns.numero" />
                  <span>N°</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.nfe" />
                  <span>N° NF-e</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.artTrt" />
                  <span>ART/TRT</span>
                </label>
                <label v-if="selectedLabel === 'Receitas por cliente'">
                  <input type="checkbox" v-model="selectedColumns.produtos" />
                  <span>Exibir produtos</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumns.respTecnico"
                  />
                  <span>Resp. Técnico</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cidade" />
                  <span>Cidade</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumns.data" />
                  <span>Data</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cliente" />
                  <span>Cliente</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cpfCnpj" />
                  <span>CPF/CNPJ</span>
                </label>
              </div>

              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumns.funcionario"
                  />
                  <span>Funciónario</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.situacao" />
                  <span>Situacão</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-receiptiti')"
          >
            Não, Obrigado!
          </button>
          <button @click="printRecept" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-venda" size="lg" hide-footer hide-header centered>
      <div class="containerModal">
        <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
              <div class="containerRadio">
                <label>
                  <input type="checkbox" v-model="finishing" />
                  <span>Finalizadas</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="[
                { value: '', text: 'Geral' },
                { value: 'Vendas por cliente', text: 'Vendas por cliente' },
                { value: 'Vendas Diarias', text: 'Vendas Diarias' },
                {
                  value: 'Vendas por Vendedor',
                  text: 'Vendas por Funcionário',
                },
                { value: 'Mais Vendidos', text: 'Mais Vendidos' },
                { value: 'details', text: 'Vendas Detalhadas' },
                {
                  value: 'NaoVendidosNosUltimos90Dias',
                  text: 'Não vendidos nos últimos 90 dias',
                },
              ]"
              v-model="selectedLabel"
            >
            </b-form-select>
            <div
              class="selectPlus"
              v-if="this.selectedLabel === 'Vendas por Vendedor'"
            >
              <label class="fixedSelect2">Selecione o Funcionário</label>
              <b-form-select
                value-field="id"
                text-field="nomeFuncionario"
                class="borderInput shadow-none"
                v-model="idEmployee"
                :options="dataEmployee"
              ></b-form-select>
            </div>
            <div
              class="selectPlus"
              v-if="this.selectedLabel === 'Vendas por cliente'"
            >
              <label class="fixedSelect2">Selecione o Cliente:</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="id"
                text-field="nome"
                :options="dataCustomers"
                v-model="idCliente"
              >
              </b-form-select>
            </div>
          </div>
        </div>
        <div class="rowContainer" style="margin: 0 !important">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione as
            colunas</span
          >
          <div class="rowContent">
            <div
              class="containerRadioReceipt"
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumns.numero" />
                  <span>N°</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.nfe" />
                  <span>N° NF-e</span>
                </label>
                <label v-if="type === 'Receita Pedido' && selectedLabel === ''">
                  <input type="checkbox" v-model="selectedColumns.produtos" />
                  <span>Exibir produtos</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumns.respTecnico"
                  />
                  <span>Resp. Técnico</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cidade" />
                  <span>Cidade</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumns.data" />
                  <span>Data</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cliente" />
                  <span>Cliente</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.cpfCnpj" />
                  <span>CPF/CNPJ</span>
                </label>
              </div>

              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumns.funcionario"
                  />
                  <span>Funciónario</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumns.situacao" />
                  <span>Situacão</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-venda')"
          >
            Não, Obrigado!
          </button>
          <button @click="printReportSales" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-clientes"
      hide-footer
      hide-header
      centered
      :modal-class="'modal-clientes-custom'"
    >
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório de Clientes?</h6>

        <div class="rowContainer">
          <span> <b-icon-people></b-icon-people> Selecione uma opção: </span>

          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="[
                { value: 'todos', text: 'Ver todos os clientes' },
                {
                  value: 'propriedadesPorCliente',
                  text: 'Relatório de propriedades por clientes',
                },
                { value: 'aniversariantesMes', text: 'Aniversariantes do mês' },
                { value: 'aniversariantesDia', text: 'Aniversariantes do dia' },
              ]"
              v-model="selectedClienteOption"
            >
            </b-form-select>
            <div
              class="selectPlus"
              v-if="this.selectedEmployeeReportOption === 'lucroPorColaborador'"
            >
              <label class="fixedSelect2">Selecione o Funcionário</label>
              <b-form-select
                value-field="id"
                text-field="nomeFuncionario"
                class="borderInput shadow-none"
                v-model="idEmployee"
                :options="employeeReportOptions"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1 mt-3">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-clientes')"
          >
            Não, Obrigado!
          </button>
          <button class="btnContent" @click="printReportClientes">
            Imprimir
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-colaboradores" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório de Funcionários?</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span> <b-icon-people></b-icon-people> Selecione uma opção: </span>

          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="[
                { value: 'geral', text: 'Relatório geral' },
                { value: 'lucroPorColaborador', text: 'Relatório de margem' },
              ]"
              v-model="selectedEmployeeReportOption"
            >
            </b-form-select>
            <div
              class="selectPlus"
              v-if="this.selectedEmployeeReportOption === 'lucroPorColaborador'"
            >
              <label class="fixedSelect2">Selecione o Funcionário</label>
              <b-form-select
                value-field="id"
                text-field="nomeFuncionario"
                class="borderInput shadow-none"
                v-model="idEmployee"
                :options="employeeReportOptions"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1 mt-3">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-colaboradores')"
          >
            Não, Obrigado!
          </button>
          <button class="btnContent" @click="printEmployeeReports">
            Imprimir
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-fornecedores" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório de Fornecedores?</h6>

        <div class="rowContainer">
          <span> <b-icon-truck></b-icon-truck> Selecione uma opção: </span>
          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="[
                { value: 'geral', text: 'Relatório de fornecedores' },
                { value: 'margem', text: 'Relatório de margem' },
              ]"
              v-model="selectedSupplierReportOption"
            ></b-form-select>
          </div>
        </div>

        <div
          class="rowContainer"
          v-if="selectedSupplierReportOption === 'margem'"
        >
          <span> <b-icon-truck></b-icon-truck> Selecione um fornecedor: </span>
          <div class="rowContent">
            <div class="selectPlus" style="width: 50%">
              <b-form-select
                value-field="id"
                text-field="nomeFantasia"
                class="borderInput shadow-none"
                v-model="idSupplier"
                :options="supplierReportOptions"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1 mt-3">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-fornecedores')"
          >
            Não, Obrigado!
          </button>
          <button class="btnContent" @click="printSupplierReports">
            Imprimir
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-sicca" hide-footer hide-header centered>
      <div class="containerModal">
        <div>
          <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

          <div class="rowContainer">
            <span>
              <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
              :</span
            >
            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="startDate"
                  />
                  <label class="user-label"> Inicio </label>
                </div>
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="endDate"
                  />
                  <label class="user-label"> Final </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-sicca')"
          >
            Não, Obrigado!
          </button>

          <button @click="generateSicca" class="btnContent">Gerar SICCA</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-siagro"
      hide-footer
      hide-header
      centered
      :disabled="siccaStatus === 'Siagro is processing'"
    >
      <div class="containerModal">
        <div>
          <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

          <div class="rowContainer">
            <span>
              <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
              :</span
            >
            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="startDate"
                  />
                  <label class="user-label"> Inicio </label>
                </div>
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="endDate"
                  />
                  <label class="user-label"> Final </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-siagro')"
          >
            Não, Obrigado!
          </button>

          <button @click="generateSiagro" class="btnContent">
            Gerar Siagro
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-adab" hide-footer hide-header centered>
      <div class="containerModal">
        <div>
          <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

          <div class="rowContainer">
            <span>
              <b-icon-filter></b-icon-filter> Informe o período, a ART/TRT ou
              ambos:</span
            >
            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="startDate"
                  />
                  <label class="user-label"> Inicio </label>
                </div>

                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="endDate"
                  />
                  <label class="user-label"> Final </label>
                </div>

                <div class="selectPlus">
                  <label class="fixedSelect2">Tipo</label>

                  <b-form-select
                    value-field="value"
                    text-field="text"
                    class="borderInput shadow-none"
                    v-model="typeReportAdab"
                    :options="[
                      { text: 'EXCEL', value: 'excel' },
                      { text: 'HTML', value: 'html' },
                    ]"
                  ></b-form-select>
                </div>
              </div>
            </div>

            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input class="input borderInput" v-model="artTrtAdab" />
                  <label class="user-label"> ART / TRT </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-adab')"
          >
            Não, Obrigado!
          </button>

          <button @click="generateAdab" class="btnContent">Gerar ADAB</button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-crea-cfta" hide-footer hide-header centered>
      <div class="containerModal">
        <div>
          <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

          <div class="rowContainer">
            <span>
              <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
              :</span
            >
            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="startDate"
                  />
                  <label class="user-label"> Inicio </label>
                </div>
                <div class="input-group">
                  <input
                    type="date"
                    class="input borderInput"
                    v-model="endDate"
                  />
                  <label class="user-label"> Final </label>
                </div>
              </div>
            </div>

            <div class="rowContent">
              <div class="searchInput">
                <div class="input-group">
                  <input
                    class="input borderInput"
                    v-model="artTrt"
                    style="width: 211px"
                  />

                  <label class="user-label"> ART / TRT </label>
                </div>
                <div class="containerRadio" v-if="reportModel === 'cfta'">
                  <label>
                    <input type="checkbox" v-model="addLeadingZeroCfta" />
                    <span
                      >Adicionar zero à esquerda no número das receitas</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-crea-cfta')"
          >
            Não, Obrigado!
          </button>

          <button @click="generateReportCreaCfta" class="btnContent">
            Imprimir
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-movStock" size="lg" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Relatório de Movimentações de estoque</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-list-ul></b-icon-list-ul> Selecione o tipo do relatório
            :</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="movimentReportTypes"
              v-model="selectedMovimentReportType"
            ></b-form-select>
          </div>
        </div>
        <div class="rowContainer" style="margin: 0 !important">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione as
            colunas</span
          >
          <div class="rowContent">
            <div
              class="containerRadioReceipt"
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.cod" />
                  <span>Cód.</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.data" />
                  <span>Data</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.quant" />
                  <span>Quant.</span>
                </label>
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumnsMov.nomeProduto"
                  />
                  <span>Nome Produto</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumnsMov.fornecedor"
                  />
                  <span>Fornecedor</span>
                </label>
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumnsMov.embalagem"
                  />
                  <span>Embalagem</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.origem" />
                  <span>Origem</span>
                </label>
              </div>
              <div style="width: 23.2%">
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.dentro" />
                  <span>Dentro Estado</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.nfe" />
                  <span>N° NF-e</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.receita" />
                  <span>N° Receita</span>
                </label>
              </div>

              <div style="width: 23.2%">
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumnsMov.registro"
                  />
                  <span>Registro</span>
                </label>
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedColumnsMov.vencimento"
                  />
                  <span>Vencimento</span>
                </label>
                <label>
                  <input type="checkbox" v-model="selectedColumnsMov.lote" />
                  <span>Lote</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-movStock')"
          >
            Não, Obrigado!
          </button>
          <button @click="printMov" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-product-movement"
      size="lg"
      hide-footer
      hide-header
      centered
    >
      <div class="containerModal2">
        <h6 class="titleModal">Relação de Movimentação de Produto</h6>

        <div class="rowContainer">
          <span><b-icon-list-ul></b-icon-list-ul> Produto e embalagem:</span>
          <div class="rowContent product-movement-grid">
            <div class="selectPlus">
              <label class="fixedSelect2">Produto</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="idAgrotoxico"
                text-field="nome"
                :options="productMovementProductOptions"
                v-model="productMovementFilters.idAgrotoxico"
              ></b-form-select>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Embalagem</label>
              <b-form-select
                class="borderInput shadow-none"
                :options="productMovementPackagingOptions"
                v-model="productMovementFilters.embalagem"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span
            ><b-icon-arrow-left-right></b-icon-arrow-left-right>
            Movimentação:</span
          >
          <div class="rowContent product-movement-grid">
            <div class="selectPlus">
              <label class="fixedSelect2">Tipo de movimentação</label>
              <b-form-select
                class="borderInput shadow-none"
                :options="productMovementTypes"
                v-model="productMovementFilters.tipo"
              ></b-form-select>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Destino do produto</label>
              <b-form-select
                class="borderInput shadow-none"
                :options="productMovementDestinations"
                v-model="productMovementFilters.destinoProduto"
              ></b-form-select>
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span><b-icon-calendar-week></b-icon-calendar-week> Período:</span>
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="productMovementFilters.startDate"
                />
                <label class="user-label">Início *</label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="productMovementFilters.endDate"
                />
                <label class="user-label">Final *</label>
              </div>
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span
            ><b-icon-journal-text></b-icon-journal-text> Tipo do
            relatório:</span
          >
          <div class="rowContent">
            <b-form-radio-group
              v-model="productMovementFilters.reportType"
              :options="productMovementReportTypes"
            ></b-form-radio-group>
          </div>
        </div>

        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-product-movement')"
          >
            Cancelar
          </button>
          <button @click="printProductMovement" class="btnContent">
            Gerar relatório
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-center1" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório de Notas?</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="statusNota"
              v-model="selectedLabel"
            >
            </b-form-select>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center1')"
          >
            Não, Obrigado!
          </button>
          <button @click="printNotes" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>

    <b-modal size="lg" id="modal-center2" hide-footer hide-header centered>
      <div class="containerModal">
        <h6 class="titleModal">Deseja Imprimir o Relatório de Contas?</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput1">
              <div class="input-group" style="width: 32%">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group" style="width: 32%">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
            <div class="containerRadio">
              <label>
                <input type="checkbox" v-model="datePayment" />
                <span>Por data Pagamento</span>
              </label>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Tipo de pesquisa</span
          >
          <div class="rowContent">
            <div class="selectPlus" v-if="type === 'entrada'">
              <label class="fixedSelect2">Selecione o Cliente:</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="id"
                text-field="nome"
                :options="dataCustomers"
                v-model="idCliente"
              >
              </b-form-select>
            </div>
            <div class="selectPlus" v-if="type === 'entrada'">
              <label class="fixedSelect2">Selecione o Funcionário</label>
              <b-form-select
                value-field="id"
                text-field="nomeFuncionario"
                class="borderInput shadow-none"
                v-model="idEmployee"
                :options="dataEmployee"
              ></b-form-select>
            </div>
            <div class="selectPlus" v-else>
              <label class="fixedSelect2">Selecione o Fornecedor</label>
              <b-form-select
                value-field="id"
                text-field="nomeFantasia"
                class="borderInput shadow-none"
                v-model="idSupplier"
                :options="allSupplier"
              ></b-form-select>
            </div>
          </div>
          <div class="rowContent">
            <div class="selectPlus">
              <label class="fixedSelect2">Situação</label>
              <b-form-select
                value-field="value"
                text-field="text"
                class="borderInput shadow-none"
                v-model="status"
                :options="filterSituationCombobox"
              ></b-form-select>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Forma de pagamento:</label>
              <b-form-select
                value-field="id"
                text-field="tipo"
                class="borderInput shadow-none"
                :options="typeFormPayment"
                v-model="idFormaDePagamento"
                size="sm"
              >
              </b-form-select>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Categoria:</label>
              <b-form-select
                value-field="id"
                text-field="nome"
                class="borderInput shadow-none"
                :options="allCategoryBills"
                v-model="idCategoryBill"
                size="sm"
              >
              </b-form-select>
            </div>

            <div class="input-group" style="width: 32%">
              <input type="text" class="input borderInput" v-model="city" />
              <label class="user-label"> Cidade: </label>
            </div>
          </div>

          <div class="rowContent" v-if="type === 'entrada'">
            <div class="containerRadio">
              <label>
                <input type="checkbox" v-model="landscape" />
                <span>Modo Paisagem</span>
              </label>
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center2')"
          >
            Não, Obrigado!
          </button>
          <button @click="printReportBills" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-center4" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>

        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
          <div class="rowContainer">
            <span>
              <b-icon-calendar-week></b-icon-calendar-week> Selecione o tipo:
            </span>
            <div class="rowContent">
              <b-form-select
                style="width: 50%"
                class="borderInput shadow-none"
                :options="[
                  { value: '', text: 'Geral' },
                  { value: 'Produtos Importados', text: 'Produtos Importados' },
                ]"
                v-model="selectedLabel"
              >
              </b-form-select>
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center4')"
          >
            Não, Obrigado!
          </button>
          <button @click="printPurchase" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-center5" hide-footer hide-header centered>
      <div class="containerModal3">
        <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 50%"
              class="borderInput shadow-none"
              :options="[
                { value: '', text: 'Geral' },
                { value: 'dia', text: 'Movimentação Diária' },
              ]"
              v-model="selectedLabel"
            >
            </b-form-select>
          </div>
        </div>
        <div class="btnModal-report-sales">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center5')"
          >
            Não, Obrigado!
          </button>
          <button @click="printSafe" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-center6" hide-footer hide-header centered>
      <div class="containerModal2">
        <h6 class="titleModal">Deseja Imprimir o Relatório?</h6>
        <div class="rowContainer1">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 60%"
              class="borderInput shadow-none"
              :options="[
                { value: '', text: 'Geral' },
                { value: 'Anual', text: 'Estoque Anual' },
                { value: 'AnualES', text: 'Estoque Anual - ES' },
                { value: 'Categoria', text: 'Vendas por Categoria' },
                {
                  value: 'Movimentacao',
                  text: 'Movimentações de Entrada/Saída',
                },
                { value: 'vendasPorProduto', text: 'Vendas por produto' },
                { value: 'produtoCliente', text: 'Produtos por cliente' },
                { value: 'produtoEmb', text: ' Estoque Produto por embalagem' },
              ]"
              v-model="selectedLabel"
              @change="showProductReportPeriodError = false"
            >
            </b-form-select>
            <div
              class="containerRadio stock-report-options"
              v-if="this.selectedLabel === 'produtoEmb'"
            >
              <label>
                <input type="checkbox" v-model="stockPositive" />
                <span>Somente Positivo</span>
              </label>
              <label>
                <input type="checkbox" v-model="groupStockLots" />
                <span>Agrupar lotes</span>
              </label>
            </div>
          </div>
        </div>
        <div class="rowContainer" v-if="this.selectedLabel === 'Categoria'">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Tipo do filtro</span
          >
          <div class="rowContent">
            <div class="selectPlus">
              <label class="fixedSelect2">Selecione a Categoria</label>
              <b-form-select
                value-field="id"
                text-field="nome"
                class="borderInput shadow-none"
                v-model="idCategoria"
                :options="categories"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div
          class="rowContainer"
          v-if="
            this.selectedLabel === 'Anual' || this.selectedLabel === 'AnualES'
          "
        >
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Informe o ano:</span
          >
          <div class="rowContent">
            <div class="selectPlus">
              <label class="fixedSelect2">Selecione o Ano</label>
              <b-form-select
                value-field="value"
                text-field="text"
                class="borderInput shadow-none"
                v-model="year"
                :options="filterYear"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div
          class="rowContainer"
          v-if="
            this.selectedLabel === 'Movimentacao' ||
            this.selectedLabel === 'produtoCliente' ||
            this.selectedLabel === 'vendasPorProduto'
          "
        >
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            Período:</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
          <small
            v-if="showProductReportPeriodError && (!startDate || !endDate)"
            class="text-danger"
          >
            Informe as datas inicial e final do período.
          </small>
        </div>
        <div class="rowContainer" v-if="selectedLabel === 'produtoEmb'">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Última movimentação:
          </span>
          <div class="rowContent">
            <div class="input-group">
              <input
                type="date"
                class="input borderInput"
                v-model="stockDate"
              />
              <label class="user-label"> Data </label>
            </div>
          </div>
          <small
            >Data opcional. Quando informada, exibe o saldo existente até essa
            data.</small
          >
        </div>
        <div
          class="rowContainer"
          v-if="
            this.selectedLabel === 'vendasPorProduto' ||
            this.selectedLabel === 'produtoCliente'
          "
        >
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Tipo do filtro</span
          >
          <div class="rowContent">
            <div class="selectPlus product-report-select">
              <InputProducts
                label="Selecione o Produto"
                text="reportName"
                typeFilter="itens"
                :isEdit="idProduto"
                :dataInput.sync="idProduto"
                :onSearch="searchReportProducts"
                :enableIconCreate="false"
                :searchFields="['nome', 'codRef']"
                :typeSlotProps="{ fistValue: 'reportName', secondValue: '' }"
              />
            </div>
          </div>
        </div>
        <div class="btnModal-report-sales1">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center6')"
          >
            Não, Obrigado!
          </button>
          <button @click="printRegisters" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-dashboard" hide-footer hide-header centered>
      <div class="containerModal1">
        <h6 class="titleModal" style="text-align: center">
          Relatório Dashboard
        </h6>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o periodo
            :</span
          >
          <div class="rowContent">
            <div class="searchInput">
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="startDate"
                />
                <label class="user-label"> Inicio </label>
              </div>
              <div class="input-group">
                <input
                  type="date"
                  class="input borderInput"
                  v-model="endDate"
                />
                <label class="user-label"> Final </label>
              </div>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione o
            tipo:</span
          >
          <div class="rowContent">
            <b-form-select
              style="width: 100%"
              class="borderInput shadow-none"
              :options="[
                { value: '', text: 'Top Culturas preescritas' },
                { value: 'IngAtivo', text: 'Ingredientes Ativos' },
              ]"
              v-model="selectedLabel"
            >
            </b-form-select>
          </div>
        </div>
        <div class="btnModal-report-sales">
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-dashboard')"
          >
            Não, Obrigado!
          </button>
          <button @click="dashboard" class="btnContent">Imprimir</button>
        </div>
      </div>
    </b-modal>

    <ModalConfirm
      typeModal="info"
      modalName="alert-modal-reports"
      title="Erro ao enviar movimentação"
      subtitle="Identificamos que ocorreu um problema ao enviar essa movimentação para o órgão do estado"
      headerIcon="b-icon-patch-exclamation-fill"
      leftButtonText="Fechar"
      :showRightButton="false"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          border-radius: 5px;
          padding: 0.5rem 0 1rem 0;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0.5rem 1.2rem 0 1.2rem;
          "
        >
          <div style="display: flex; gap: 0.6rem; align-items: center">
            <div class="contentNewAlertIcon">
              <b-icon-info-circle style="color: red" scale="0.9" />
            </div>

            <p
              style="
                margin: 0 0 0 0;
                font-size: 0.8rem;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Corrija os erros abaixo!
            </p>
          </div>

          <p
            style="
              margin: 0;
              background-color: rgb(255 0 0 / 12%);
              border-radius: 50px;
              padding: 0.15rem 0.8rem;
              font-size: 0.65rem;
              color: brown;
            "
          >
            {{
              reportErrors.length === 1
                ? `${reportErrors.length} Erro`
                : `${reportErrors.length} Erros`
            }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
            overflow: auto;
            width: 100%;
            max-height: 200px;
            padding: 0.2rem 1.2rem 0.6rem 1.2rem;
          "
        >
          <div
            v-for="(errors, idx) in reportErrors"
            :key="idx"
            class="contentReportError"
          >
            <div
              style="
                min-width: 23px;
                min-height: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgb(255 0 0 / 12%);
                border-radius: 50%;
                font-size: 0.68rem;
                color: brown;
              "
            >
              {{ idx + 1 }}
            </div>

            <p
              style="
                margin: 0;
                font-size: 0.75rem;
                color: oklch(44.6% 0.03 256.802);
                font-family: Poppins-Medium, sans-serif !important;
              "
            >
              {{ errors }}
            </p>
          </div>
        </div>
      </div>
    </ModalConfirm>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

import ReportsAccounting from "../ReportsAccounting/ReportsAccounting.vue";
import printReportGeneral from "../../reports/General";
import printReportPerEmployee from "../../reports/sale/perEmployee";
import printReportClient from "../../reports/sale/perClient";
import printReportBills from "../../reports/Bills/perType";
import { printDashboard } from "../../reports/Dashboard";
import printProductCategory from "../../reports/Products/PerCategory";
import stockByEmb from "../../reports/Products/StockEmb";
import printProductAnual from "../../reports/Products/Anual";
import printMovement from "../../reports/Products/Moviment";
import printReportRegisters from "../../reports/Registers";
import printReportCollaborator from "../../reports/collaborator";
import api from "../../services/axios";
import printPrescriptionReports from "../../reports/prescriptions/index";

import serviceSupplier from "../../services/serviceSupplier";
import SafeService from "../../services/serviceSafe";
import serviceCategory from "../../services/serviceCategory";
import servicePaymentForm from "../../services/servicePaymentForm";
import serviceCustomer from "../../services/serviceCustomer";
import ServiceCategoryBill from "../../services/serviceCategoryBill";
import { DateTime } from "luxon";
import serviceProducts from "../../services/serviceProducts";
import { reportSalesByProducts } from "../../reports/Products/SalesByProdutcts";
import { prodByClient } from "../../reports/Products/ProductPerClient";
import printMovStock from "../../reports/Products/MovStock";
import printProductMovementRelation from "../../reports/Products/ProductMovementRelation";
import printReportNotes from "../../reports/Notes";
import siccaService from "../../services/serviceSicca";
import serviceAdab from "../../services/serviceAdab";
import serviceSiagro from "../../services/serviceSiagro";

import Acre from "../../assets/States/acre.jpg";
import Parana from "../../assets/States/parana.jpg";
import Alagoas from "../../assets/States/alagoas.jpg";
import Amapa from "../../assets/States/amapa.jpg";
import Amazonas from "../../assets/States/amazonas.jpg";
import Bahia from "../../assets/States/bahia.jpg";
import Ceara from "../../assets/States/ceara.jpg";
import Espirito from "../../assets/States/espirito_santo.jpg";
import Goias from "../../assets/States/goias.jpg";
import Maranhao from "../../assets/States/maranhao.jpg";
import MatoGrosso from "../../assets/States/mato_grosso.jpg";
import MatoSul from "../../assets/States/mato_grosso_do_sul.jpg";
import Minas from "../../assets/States/minas_gerais.jpg";
import Para from "../../assets/States/para.jpg";
import Paraiba from "../../assets/States/paraiba.jpg";
import Pernambuco from "../../assets/States/pernambuco.jpg";
import Piaui from "../../assets/States/piaui.jpg";
import Rio from "../../assets/States/rio_de_janeiro.jpg";
import RioGrandeNorte from "../../assets/States/rio_grande_do_norte.jpg";
import RioGrandeSul from "../../assets/States/rio_grande_do_sul.jpg";
import Rondonia from "../../assets/States/rondonia.jpg";
import Roraima from "../../assets/States/roraima.jpg";
import SantaCatarina from "../../assets/States/santa_catarina.jpg";
import SaoPaulo from "../../assets/States/sao_paulo.jpg";
import Sergipe from "../../assets/States/sergipe.jpg";
import Tocantins from "../../assets/States/tocantins.jpg";
import serviceSicca from "../../services/serviceSicca";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import InputProducts from "../UI/CustomInputs/InputProducts.vue";

import axios from "axios";

export default {
  components: {
    ReportsAccounting,
    ModalConfirm,
    InputProducts,
  },
  data() {
    return {
      Acre: Acre,
      Alagoas: Alagoas,
      Amapa: Amapa,
      Amazonas: Amazonas,
      Bahia: Bahia,
      Ceara: Ceara,
      Espirito: Espirito,
      Goias: Goias,
      Maranhao: Maranhao,
      MatoGrosso: MatoGrosso,
      MatoSul: MatoSul,
      Minas: Minas,
      Para: Para,
      Paraiba: Paraiba,
      Pernambuco: Pernambuco,
      Piaui: Piaui,
      Rio: Rio,
      RioGrandeNorte: RioGrandeNorte,
      RioGrandeSul: RioGrandeSul,
      Rondonia: Rondonia,
      Roraima: Roraima,
      SantaCatarina: SantaCatarina,
      SaoPaulo: SaoPaulo,
      Sergipe: Sergipe,
      Tocantins: Tocantins,
      Parana: Parana,
      isSimple: false,
      datePayment: false,
      idProduto: null,
      type: "",
      startDate: "",
      endDate: "",
      showProductReportPeriodError: false,
      selectedLabel: "",
      status: "",
      idEmployee: "",
      idCategoria: "",
      idSupplier: "",
      idCliente: "",
      idFormaDePagamento: "",
      idCategoryBill: "",
      dataEmployee: [],
      categories: [],
      allSupplier: [],
      allAccounts: [],
      dataCustomers: [],
      dataProducts: [],
      year: "",
      selectedClienteOption: "todos",
      selectedEmployeeReportOption: "geral",
      selectedSupplierReportOption: "geral",
      selectedMovimentReportType: "geral",
      selectedMonth: null,
      typeFormPayment: [],
      reportErrors: [],
      allCategoryBills: [],
      statusNota: [
        { value: "Operação", text: "Operação" },
        { value: "Emitida", text: "Emitida" },
        { value: "Cancelada", text: "Cancelada" },
        { value: "Não enviada", text: "Não enviada" },
        { value: "Contingencia", text: "Contingência" },
        { value: "Processamento", text: "Processamento" },
        { value: "Corrigida", text: "Corrigida" },
        { value: "", text: "Selecione" },
      ],
      filterSituationCombobox: [
        { value: "Pago", text: "Pago" },
        { value: "Pago Parcial", text: "Pago Parcial" },
        { value: "Perda", text: "Perda" },
        { value: "Em aberto", text: "Em aberto" },
        { value: "Vencido", text: "Vencido" },
        { value: "", text: "Selecione a situação" },
      ],
      filterYear: [
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" },
        { value: "2025", text: "2025" },
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
        { value: "2028", text: "2028" },
        { value: "2029", text: "2029" },
        { value: "2030", text: "2030" },
        { value: "2031", text: "2031" },
        { value: "2032", text: "2032" },
      ],
      movimentReportTypes: [
        { value: "geral", text: "Relatório geral" },
        { value: "entrada", text: "Relatório de entradas" },
        { value: "saida", text: "Relatório de saídas" },
      ],
      productMovementFilters: {
        idAgrotoxico: "",
        embalagem: "",
        tipo: "",
        destinoProduto: "",
        startDate: "",
        endDate: "",
        reportType: "detalhado",
      },
      productMovementTypes: [
        { value: "", text: "Todos os tipos" },
        { value: "Compra", text: "Compra" },
        { value: "Entrada", text: "Entrada" },
        { value: "Inventario Entrada", text: "Inventário - Entrada" },
        { value: "Transferência Entrada", text: "Transferência - Entrada" },
        { value: "Devolução Entrada", text: "Devolução - Entrada" },
        { value: "Venda", text: "Venda" },
        { value: "Devolução", text: "Devolução - Saída" },
        { value: "Inventario Saida", text: "Inventário - Saída" },
        { value: "Transferência Saida", text: "Transferência - Saída" },
      ],
      productMovementDestinations: [
        { value: "", text: "Todos" },
        { value: "Dentro Estado", text: "Dentro do Estado" },
        { value: "Fora Estado", text: "Fora do Estado" },
      ],
      productMovementReportTypes: [
        { value: "simplificado", text: "Simplificado" },
        { value: "detalhado", text: "Detalhado" },
      ],
      landscape: false,
      city: "",
      selectedTabLabel: "Gerais",
      tabs: [
        { value: "Gerais", text: "Gerais" },
        { value: "Relatórios Regulatórios", text: "Relatórios Regulatórios" },
        { value: "Contábeis", text: "Contábeis" },
      ],
      reportModel: null,
      artTrt: "",
      addLeadingZeroCfta: false,
      selectedColumns: {
        numero: true,
        nfe: true,
        produtos: false,
        artTrt: true,
        respTecnico: true,
        funcionario: false,
        situacao: false,
        data: true,
        cliente: true,
        cpfCnpj: true,
        cidade: true,
      },
      selectedColumnsMov: {
        cod: true,
        data: true,
        quant: true,
        fornecedor: true,
        nomeProduto: true,
        embalagem: true,
        origem: true,
        dentro: true,
        nfe: true,
        receita: true,
        registro: true,
        vencimento: true,
        lote: true,
      },
      finishing: true,
      stockPositive: false,
      groupStockLots: false,
      stockDate: "",
      intervalSiccaId: "",
      intervalSiagroId: "",
      intervalAdabId: "",
      siccaStatus: false,
      siagroStatus: false,
      adabStatus: false,
      siccaFile: null,
      siagroFiles: {},
      adabFile: null,
      typeReportAdab: "excel",
      artTrtAdab: "",
    };
  },
  computed: {
    employeeReportOptions() {
      return [
        { id: "", nomeFuncionario: "Todos os funcionários" },
        ...this.dataEmployee,
      ];
    },
    supplierReportOptions() {
      return [
        { id: "", nomeFantasia: "Todos os fornecedores" },
        ...this.allSupplier.map((supplier) => ({
          ...supplier,
          nomeFantasia: supplier.nomeFantasia || supplier.razaoSocial || "--",
        })),
      ];
    },
    productMovementProductOptions() {
      const products = this.dataProducts
        .filter((product) => product.idAgrotoxico)
        .map((product) => ({
          idAgrotoxico: product.idAgrotoxico,
          nome: product.nome,
        }));
      const uniqueProducts = Array.from(
        new Map(
          products.map((product) => [product.idAgrotoxico, product])
        ).values()
      );

      return [
        { idAgrotoxico: "", nome: "Todos os produtos" },
        ...uniqueProducts,
      ];
    },
    productMovementPackagingOptions() {
      const packaging = this.dataProducts
        .filter((product) => product.idAgrotoxico && product.embalagem)
        .map((product) => product.embalagem);

      return [
        { value: "", text: "Todas as embalagens" },
        ...Array.from(new Set(packaging))
          .sort((first, second) => first.localeCompare(second))
          .map((item) => ({ value: item, text: item })),
      ];
    },
  },
  methods: {
    ...mapMutations(["SET_HTML_TO_PRINT"]),
    async searchReportProducts(id, query, filterType, page) {
      try {
        const products = await serviceProducts.fillComboBoxWithPaginate(
          id,
          query,
          filterType,
          page
        );
        return products.map((product) => ({
          ...product,
          reportName:
            this.selectedLabel === "vendasPorProduto" && product.embalagem
              ? `${product.nome} - ${product.embalagem}`
              : product.nome,
        }));
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
        return [];
      }
    },
    handleType(event) {
      this.type = event.currentTarget.name;

      if (this.type !== "Receita Pedido") {
        this.selectedColumns.produtos = false;
      }
    },

    storeLabelName(labelName) {
      this.selectedLabel = labelName;
    },

    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },

    async getCustomersForSelectBox() {
      try {
        const data = await serviceCustomer.getCustomersForSelectBox();
        this.dataCustomers = data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getProductsForSelectBox() {
      try {
        const data = await serviceProducts.getProductsForSelectBox();
        this.dataProducts = data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async sumPerAccount() {
      const data = await SafeService.sumPerAccount();
      this.allAccounts = data?.data ?? [];
    },
    async downloadSicca() {
      const fileData = this.siccaFile;

      if (!fileData) {
        return;
      }

      const filename = "sicca.txt";

      const blob = new Blob([fileData], { type: "text/plain;charset=utf-8" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },

    async downloadSiagro() {
      const fileData = this.siagroFiles;

      if (!fileData) {
        return;
      }

      const { csvReceita, csvVenda } = fileData;

      async function generateFiles(filename, aux) {
        const blob = new Blob([aux], { type: "text/plain;charset=utf-8" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }

      await generateFiles("receitas.csv", csvReceita);
      await generateFiles("vendas.csv", csvVenda);
    },

    async downloadAdab() {
      const fileData = this.adabFile;

      if (!fileData || !fileData.content) {
        return;
      }

      const byteCharacters = atob(fileData.content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: fileData.mimeType });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileData.fileName;
      link.click();

      window.URL.revokeObjectURL(link.href);
    },

    async listEmployeesSelectBox() {
      try {
        const { data } = await api.get("/employees/combobox/fill");
        this.dataEmployee = data.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async findAllCategories() {
      try {
        this.categories = await serviceCategory.fillComobobox();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar as categorias do produto",
          type: "info",
        });
      }
    },

    async getAllSuppliers() {
      const result = await serviceSupplier.fillComobobox();
      this.allSupplier = result;
    },

    async getAllPayment() {
      const result = await servicePaymentForm.getAllPayment();
      this.typeFormPayment = result.sort((a, b) => a.cod - b.cod);
    },
    async getAllCategoryBill() {
      const result = await ServiceCategoryBill.fillComobobox();
      this.allCategoryBills = result;
    },
    async generateSicca() {
      try {
        this.reportErrors = [];
        await serviceSicca.generate(this.startDate, this.endDate);

        this.siccaStatus = "Sicca is processing";

        this.checkSiccaIsFinished();

        this.$toast.info("Aguarde, o SICCA esta sendo gerado!");
        this.$bvModal.hide("modal-sicca");
      } catch (error) {
        if (axios.isAxiosError(error)) {
          let msg = error?.response?.data?.messageErrors ?? [];

          this.reportErrors = Array.isArray(msg) ? msg : [];
        } else {
          this.$toast.info("Ocorreu um problema ao gerar o SICCA");
        }
      } finally {
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async verifySicca() {
      try {
        const result = await siccaService.verify();

        if (
          !result ||
          typeof result !== "object" ||
          !Object.keys(result).length
        ) {
          this.siccaStatus = null;
          this.clearIntervalSicca();
          return;
        }

        this.siccaStatus = result.message;

        if (this.siccaStatus === "Sicca is processed") {
          this.siccaFile = result.file;
          this.clearIntervalSicca();
        } else if (result.message === "SiccaController is working") {
          this.clearIntervalSicca();
        } else if (result.message === "Sicca is processing") {
          this.checkSiccaIsFinished();
        } else {
          this.siccaStatus = null;
          this.clearIntervalSicca();
        }
      } catch (error) {
        this.clearIntervalSicca();

        if (axios.isAxiosError(error)) {
          let msg = error?.response?.data?.messageErrors ?? [];

          this.reportErrors = Array.isArray(msg) ? msg : [];
        } else {
          this.$toast.info("Ocorreu um problema ao gerar o SICCA");
        }
      } finally {
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async generateSiagro() {
      try {
        await serviceSiagro.generate(this.startDate, this.endDate);

        this.siccaStatus = "Siagro is processing";

        this.checkSiagroIsFinished();

        this.$toast.info("Aguarde, o SIAGRO esta sendo gerado!");
        this.$bvModal.hide("modal-siagro");
      } catch (error) {
        if (error?.response?.data?.message === "Siagro is already processing") {
          return this.$toast.info(
            "O relatório já está sendo gerado! Aguarde por favor"
          );
        }

        this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao gerar o Siagro"
        );
      }
    },

    async verifySiagro() {
      try {
        const result = await serviceSiagro.verify();

        if (result && Object.keys(result)) {
          this.siagroStatus = result.message;

          if (this.siagroStatus === "Siagro is processed") {
            this.siagroFiles = result.files;
            this.clearIntervalSiagro();
          } else if (result.message === "SiagroController is working") {
            this.clearIntervalSiagro();
          } else {
            this.siagroStatus = null;
          }
        }
      } catch (error) {
        this.clearIntervalSiagro();

        if (error?.response?.data?.message === "Siagro is already processing") {
          return this.$toast.info(
            "O relatório já está sendo gerado! Aguarde por favor"
          );
        }

        this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao gerar o SIAGRO"
        );
      }
    },

    async generateAdab() {
      const hasStartDate = Boolean(this.startDate);
      const hasEndDate = Boolean(this.endDate);
      const hasArtTrt = Boolean(this.artTrtAdab.trim());

      if (hasStartDate !== hasEndDate) {
        return this.$toast.info("Informe as datas inicial e final do período");
      }

      if (!hasStartDate && !hasArtTrt) {
        return this.$toast.info("Informe um período ou uma ART/TRT");
      }

      try {
        const isExcel = this.typeReportAdab === "excel" ? true : false;

        if (hasArtTrt) {
          await serviceAdab.generateByArt(
            this.startDate,
            this.endDate,
            this.artTrtAdab.trim(),
            isExcel
          );
        } else {
          await serviceAdab.generate(this.startDate, this.endDate, isExcel);
        }

        localStorage.setItem("typeReportAdab", this.typeReportAdab);

        this.adabStatus = "Report ADAB is processing";

        this.checkAdabIsFinished();

        this.$toast.info("Aguarde, o relatório ADAB esta sendo gerado!");
        this.$bvModal.hide("modal-adab");
      } catch (error) {
        this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao gerar o relatório ADAB"
        );
      }
    },

    async verifyAdab() {
      try {
        const result = await serviceAdab.verify(
          this.typeReportAdab === "excel" ? true : false
        );

        if (result && Object.keys(result)) {
          this.adabStatus = result.message;

          if (this.adabStatus === "Report ADAB is processed") {
            this.adabFile = result.file;
            this.clearIntervalAdab();
          }

          if (this.adabStatus === "ReportAdabController is working") {
            this.clearIntervalAdab();
          }
        }
      } catch (error) {
        this.clearIntervalAdab();

        this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao gerar o SICCA"
        );
      }
    },

    async generateReportCreaCfta() {
      if (this.reportModel === "cfta") {
        const report = await printPrescriptionReports(
          "reportCfta",
          this.startDate,
          this.endDate,
          this.artTrt,
          this.addLeadingZeroCfta
        );

        this.SET_HTML_TO_PRINT(report);
      } else {
        const result = await printPrescriptionReports(
          "reportCrea",
          this.startDate,
          this.endDate,
          this.artTrt
        );
        this.SET_HTML_TO_PRINT(result);
      }
      this.clearSearch();
    },

    handleOpenModalCreaCfta(model) {
      this.$bvModal.show("modal-crea-cfta");
      this.reportModel = model;
    },

    async printRecept() {
      const columnsJson = JSON.stringify(this.selectedColumns);
      if (this.selectedLabel === "") {
        const report = await printPrescriptionReports(
          "report",
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
        this.SET_HTML_TO_PRINT(report);
      } else if (this.selectedLabel === "Por ART/TRT") {
        const artTrt = this.artTrt.trim();
        if (!artTrt) {
          return this.$toast.info("Informe a ART/TRT");
        }

        const report = await printPrescriptionReports(
          "reportCfta",
          this.startDate,
          this.endDate,
          artTrt,
          false
        );

        this.SET_HTML_TO_PRINT(report);
      } else if (this.selectedLabel === "Estorno de Embalagem") {
        const report = await printPrescriptionReports(
          "estorno",
          this.startDate,
          this.endDate
        );

        this.SET_HTML_TO_PRINT(report);
      } else if (this.selectedLabel === "Produtos da Receita") {
        const report = await printPrescriptionReports(
          "reportProduct",
          this.startDate,
          this.endDate
        );

        this.SET_HTML_TO_PRINT(report);
      } else if (this.selectedLabel === "Receitas por cliente") {
        if (this.idCliente) {
          const report = await printPrescriptionReports(
            "reportClient",
            this.idCliente,
            this.startDate,
            this.endDate,
            columnsJson
          );
          this.SET_HTML_TO_PRINT(report);
        } else {
          const report = await printPrescriptionReports(
            "reportClient",
            null,
            this.startDate,
            this.endDate,
            columnsJson
          );
          this.SET_HTML_TO_PRINT(report);
        }
      } else if (this.selectedLabel === "Receitas Diarias") {
        const today = DateTime.local();
        this.startDate = today.toSQLDate();
        this.endDate = today.toSQLDate();
        const report = await printPrescriptionReports(
          "report",
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
        this.SET_HTML_TO_PRINT(report);
      }

      this.clearSearch();
    },

    printReportSales() {
      const columnsJson = JSON.stringify(this.selectedColumns);
      if (this.selectedLabel === "") {
        printReportGeneral(
          "allSales",
          this.type,
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
      } else if (this.selectedLabel === "Vendas por cliente") {
        if (this.idCliente) {
          printReportClient(
            this.idCliente,
            this.type,
            this.startDate,
            this.endDate
          );
        } else {
          printReportGeneral(
            "client",
            this.type,
            this.startDate,
            this.endDate,
            columnsJson,
            this.finishing
          );
        }
      } else if (this.selectedLabel === "Vendas por Vendedor") {
        if (this.selectedLabel === "Vendas por Vendedor" && this.idEmployee) {
          printReportPerEmployee(
            this.idEmployee,
            this.type,
            this.startDate,
            this.endDate,
            this.isSimple
          );
        } else {
          printReportGeneral(
            "employee",
            this.type,
            this.startDate,
            this.endDate,
            columnsJson,
            this.finishing
          );
        }
      } else if (this.selectedLabel === "Mais Vendidos") {
        printReportGeneral(
          "bestSellers",
          this.type,
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
      } else if (this.selectedLabel === "Vendas Diarias") {
        printReportGeneral(
          "daily",
          this.type,
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
      } else if (this.selectedLabel === "NaoVendidosNosUltimos90Dias") {
        printReportGeneral(
          "naoVendidosNosUltimos90Dias",
          this.type,
          this.startDate,
          this.endDate,
          columnsJson,
          this.finishing
        );
      } else if (this.selectedLabel === "details") {
        printReportGeneral("details", this.type, this.startDate, this.endDate);
      }

      this.clearSearch();
    },

    printReportBills() {
      printReportBills(
        this.type,
        this.status,
        this.idCliente,
        this.idEmployee,
        this.idSupplier,
        this.idCategoryBill,
        this.idFormaDePagamento,
        this.startDate,
        this.endDate,
        this.landscape,
        this.datePayment,
        this.city
      );
      this.clearSearch();
    },

    printRegisters() {
      if (
        (this.selectedLabel === "vendasPorProduto" ||
          this.selectedLabel === "produtoCliente") &&
        (!this.startDate || !this.endDate)
      ) {
        this.showProductReportPeriodError = true;
        return;
      }

      if (this.selectedLabel === "Categoria") {
        printProductCategory(this.idCategoria);
      } else if (this.selectedLabel === "Anual") {
        printProductAnual(this.year);
      } else if (this.selectedLabel === "AnualES") {
        printProductAnual(this.year, "ES");
      } else if (this.selectedLabel === "Movimentacao") {
        printMovement(this.startDate, this.endDate);
      } else if (this.selectedLabel === "vendasPorProduto") {
        reportSalesByProducts(this.idProduto, this.startDate, this.endDate);
      } else if (this.selectedLabel === "produtoCliente") {
        prodByClient("simple", this.idProduto, this.startDate, this.endDate);
      } else if (this.selectedLabel === "produtoEmb") {
        stockByEmb(this.stockPositive, this.groupStockLots, this.stockDate);
      } else {
        printReportRegisters(this.type);
      }
      this.clearSearch();
    },

    printAllRegisters(type) {
      printReportRegisters(type);
    },

    printSafe() {
      const formattedDate = DateTime.now();
      if (this.selectedLabel === "dia") {
        this.startDate = formattedDate.toFormat("yyyy-MM-dd");
        this.endDate = formattedDate.toFormat("yyyy-MM-dd");
        printReportGeneral("safes", this.type, this.startDate, this.endDate);
      } else {
        printReportGeneral("safes", this.type, this.startDate, this.endDate);
      }
      this.clearSearch();
    },

    dashboard() {
      if (this.selectedLabel === "IngAtivo") {
        printDashboard("ingrediente", this.startDate, this.endDate);
      } else {
        printDashboard("cultura", this.startDate, this.endDate);
      }
      this.clearSearch();
    },

    printRegistersReports(type, ...args) {
      printReportRegisters(type, ...args);
      this.clearSearch();
    },

    verifyTypeService() {
      if (this.type === "nfse") {
        this.printNfse();
      } else {
        this.printOs();
      }
    },

    printNfse() {
      printReportGeneral("nfse", this.type, this.startDate, this.endDate);
      this.clearSearch();
    },

    printOs() {
      printReportGeneral("os", this.type, this.startDate, this.endDate);
      this.clearSearch();
    },

    printNotes() {
      if (this.selectedLabel === "Operação") {
        printReportGeneral("notesOp", this.type, this.startDate, this.endDate);
      } else {
        printReportNotes(
          this.type,
          this.selectedLabel,
          this.startDate,
          this.endDate
        );
      }
      this.clearSearch();
    },

    printMov() {
      const columnsJson = JSON.stringify(this.selectedColumnsMov);
      printMovStock(
        this.startDate,
        this.endDate,
        columnsJson,
        this.selectedMovimentReportType
      );

      this.clearSearch();
    },

    printProductMovement() {
      const filters = this.productMovementFilters;

      if (!filters.startDate || !filters.endDate) {
        this.$toast.info("Informe a data inicial e a data final.");
        return;
      }

      if (filters.startDate > filters.endDate) {
        this.$toast.info("A data inicial não pode ser maior que a data final.");
        return;
      }

      printProductMovementRelation(filters);
      this.$bvModal.hide("modal-product-movement");
      this.clearProductMovementFilters();
    },

    clearProductMovementFilters() {
      this.productMovementFilters = {
        idAgrotoxico: "",
        embalagem: "",
        tipo: "",
        destinoProduto: "",
        startDate: "",
        endDate: "",
        reportType: "detalhado",
      };
    },

    printPurchase() {
      if (this.selectedLabel === "") {
        printReportGeneral("purchase", this.type, this.startDate, this.endDate);
      }
      if (this.selectedLabel === "Produtos Importados") {
        printReportGeneral(
          "purchaseProducts",
          this.type,
          this.startDate,
          this.endDate
        );
      }
      this.clearSearch();
    },
    printReportClientes() {
      const token = localStorage.getItem("token");

      if (this.selectedClienteOption === "todos") {
        printReportRegisters("Clientes");
      } else if (
        this.selectedClienteOption === "propriedadesPorCliente"
      ) {
        printReportRegisters("PropriedadesPorCliente");
      } else if (this.selectedClienteOption === "aniversariantesMes") {
        const month = this.selectedMonth || new Date().getMonth() + 1;
        window.open(
          `${process.env.VUE_APP_URL_BACKEND}/customers/generate/report/birthday?month=${month}&auth=${token}`
        );
      } else if (this.selectedClienteOption === "aniversariantesDia") {
        window.open(
          `${process.env.VUE_APP_URL_BACKEND}/customers/generate/report/birthday/day?auth=${token}`
        );
      }

      this.$bvModal.hide("modal-clientes");
    },
    printEmployeeReports() {
      if (this.selectedEmployeeReportOption === "geral") {
        printReportCollaborator("Colaborador");
      } else if (this.selectedEmployeeReportOption === "lucroPorColaborador") {
        printReportCollaborator(
          "LucroPorColaborador",
          this.startDate,
          this.endDate,
          this.idEmployee
        );
      }

      this.$bvModal.hide("modal-colaboradores");
    },
    printSupplierReports() {
      if (this.selectedSupplierReportOption === "geral") {
        printReportRegisters("Fornecedores");
      } else if (this.selectedSupplierReportOption === "margem") {
        printReportRegisters("MargemFornecedor", this.idSupplier);
      }

      this.$bvModal.hide("modal-fornecedores");
    },
    clearSearch() {
      this.type = "";
      this.startDate = "";
      this.endDate = "";
      this.showProductReportPeriodError = false;
      this.stockDate = "";
      this.selectedLabel = "";
      this.status = "";
      this.year = "";
      this.idEmployee = "";
      this.selectedMovimentReportType = "geral";
      this.idSupplier = "";
      this.idCliente = "";
      this.idCategoria = "";
      this.idCategoryBill = "";
      this.idFormaDePagamento = "";
      this.isSimple = false;
      this.$bvModal.hide("modal-receiptiti");
      this.$bvModal.hide("modal-crea-cfta");
      this.$bvModal.hide("modal-clientes");
      this.$bvModal.hide("modal-colaboradores");
      this.$bvModal.hide("modal-fornecedores");
      this.$bvModal.hide("modal-adab");
      this.$bvModal.hide("modal-sicca");
      this.$bvModal.hide("modal-venda");
      this.$bvModal.hide("modal-center1");
      this.$bvModal.hide("modal-center2");
      this.$bvModal.hide("modal-center5");
      this.$bvModal.hide("modal-center6");
      this.idProduto = null;
      this.landscape = false;
      this.reportModel = null;
      this.artTrt = "";
      this.artTrtAdab = "";
      this.addLeadingZeroCfta = false;
      this.finishing = true;
      this.city = "";
      this.selectedEmployeeReportOption = "geral";
      this.selectedSupplierReportOption = "geral";
    },

    clearIntervalSicca() {
      clearInterval(this.intervalSiccaId);
      this.intervalSiccaId = null;
    },

    checkSiccaIsFinished() {
      if (this.intervalSiccaId) {
        return;
      }

      this.intervalSiccaId = setInterval(() => {
        this.verifySicca();
      }, 10000);
    },

    checkSiagroIsFinished() {
      this.intervalSiagroId = setInterval(() => {
        this.verifySiagro();
      }, 10000);
    },

    clearIntervalSiagro() {
      clearInterval(this.intervalSiagroId);
      this.intervalSiagroId = null;
    },

    clearIntervalAdab() {
      clearInterval(this.intervalAdabId);
      this.intervalAdabId = null;
    },

    checkAdabIsFinished() {
      this.intervalAdabId = setInterval(() => {
        this.verifyAdab();
      }, 10000);
    },
  },
  mounted() {
    this.listEmployeesSelectBox();
    this.findAllCategories();
    this.getAllSuppliers();
    this.getAllPayment();
    this.getAllCategoryBill();
    this.sumPerAccount();
    this.getCustomersForSelectBox();
    this.getProductsForSelectBox();
    this.verifySicca();
    this.verifySiagro();

    this.typeReportAdab = localStorage.getItem("typeReportAdab") || "excel";

    this.verifyAdab();
    this.checkSiagroIsFinished();
    this.checkAdabIsFinished();
  },
  beforeDestroy() {
    this.clearIntervalSicca();
    this.clearIntervalSiagro();
    this.clearIntervalAdab();
  },
};
</script>
<style scoped>
.contentAlertIcon {
  width: 25px;
  min-width: 25px;
  height: 25px;
  min-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 0 0 / 12%);
  border-radius: 8px;
}

.contentReportError {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  box-shadow: rgb(222, 222, 222) 0px 0px 3px 1px;
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
}

.report-card {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  padding: 16px 10px 16px 10px;
  text-align: left;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.015);
  outline: none;
}

.report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e1;
}

.reports-wrapper {
  border-radius: 0 28px 28px 28px;
  padding: 5px 15px 10px 15px;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  background-color: #f8fafc;
  margin-bottom: 20px;
}

.page-header {
  margin-bottom: 5px;
}

.main-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0px;
  text-align: center;
}

.reports-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.section-icon {
  font-size: 16px;
  margin-right: 8px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

.section-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  margin-left: 8px;
  background-color: #e6f7ed;
  color: #10b981;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 10px;
}

@media (min-width: 640px) {
  .cards-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .cards-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: #edfcf2;
  color: #22c55e;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  font-size: 21px;
}

.card-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 8px;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 2px;
}

.card-description {
  font-size: 11px;
  color: #64748b;
  line-height: 1.4;
}

.color-vendas {
  color: #403b74;
}

.color-financeiro {
  color: #3e66ae;
}

.color-fiscal {
  color: #48b865;
}

.color-cadastros {
  color: #403b74;
}

.color-outros {
  color: #3e66ae;
}

.icon-wrapper.image-icon {
  background-color: transparent;
  width: 50px;
  height: 35px;
  border-radius: 4px;
  border: 1px solid #f1f5f9;
}

.icon-wrapper.image-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.download-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #22c55e;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.download-badge:hover {
  transform: scale(1.1);
  background-color: #16a34a;
}

.card-processing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 197, 94, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.info-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background-color: #f1f5f9;
  border-radius: 8px;
  color: #64748b;
  font-size: 13px;
  border: 1px dashed #cbd5e1;
}

.report-card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(0.4);
}

.report-card:disabled:hover {
  transform: none;
  box-shadow: none;
}

.dashboard {
  width: 100%;
  margin-top: 55px;
  margin-left: 80px;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  height: 40px;
  width: 100%;
  gap: 1px;
  transition: transform 0.5s ease-in-out;
}

.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 35px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 0 10px;
  background: #fafafa;
  color: #000000;
  font-size: 13px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  background-color: #ececec;
  border-bottom: 3px solid #006458;
  color: #006458;
  border-radius: 5px 5px 0 0;
}

.StatementOnAccountItem:hover {
  background-color: #006458;
  color: white;
}

.StatementOnAccountItem:focus {
  outline: none;
}

.title {
  font-weight: bold;
  font-size: 1.2rem;
  color: gray;
  width: 100%;
  display: flex;
  justify-content: center;
}

.title span {
  cursor: context-menu;
}

.subtitle {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  gap: 10px;
  margin: 0 auto;
  border-bottom: 1px solid rgb(206, 206, 206);
}

.container {
  display: flex;
  justify-content: space-around;
  height: 65vh;
  flex-direction: column;
}

.contentIconDownload {
  position: absolute;
  top: -1px;
  right: 10px;
  z-index: 200;
  width: 40px;
  height: 25px;
  background-color: #006256;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 3px 1px #0000003b;
  transition: ease 0.1s;
}

.contentIconDownload:hover {
  background-color: #004c43;
  transition: ease 0.1s;
}

.contentCard {
  display: flex;
  gap: 10px;
}

.containerStates {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contentCardStates {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 20px;
}

.cardItem {
  display: flex;
  width: 23%;
  height: 50px;
  border: 1px solid rgb(215, 215, 215);
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  padding: 6px 12px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  z-index: 50;
  letter-spacing: 1px;
  color: rgb(85, 85, 85);
  background: rgba(255, 255, 255, 0.438);
  box-shadow: -2px 12px 2px -10px rgba(0, 0, 0, 0.237);
}

.cardItem:hover {
  background: rgba(238, 237, 237, 0.678);
}

.cardStateItem {
  display: flex;
  width: 200px;
  height: 50px;
  border: 1px solid rgb(215, 215, 215);
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  padding: 6px 12px;
  gap: 10px;
  cursor: pointer;
  font-weight: bold;
  justify-content: flex-start;
  align-items: center;
  z-index: 50;
  letter-spacing: 1px;
  color: rgb(85, 85, 85);
  background: rgb(255, 255, 255);
  box-shadow: -2px 12px 2px -10px rgba(0, 0, 0, 0.237);
}

.cardStateItem:hover {
  background: rgba(238, 237, 237, 0.678);
}

.cardStateItem:disabled {
  pointer-events: none;
  opacity: 0.5;
  background: #cdcdcd;
  color: #272727;
}

.rocketBkg {
  width: 400px;
  height: 400px;
  background: transparent;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 20;
  margin: 0 50px 0 0;
  opacity: 0.5;
}

.spin {
  color: white;
  width: 20px;
  height: 20px;
}

.containerModal {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.containerModal2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.containerModal1 {
  height: 30vh;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.btnModal-report-sales {
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  bottom: 0;
  left: 0;
}

.btnModal-report-sales1 {
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
  font-size: 11px;
}

.searchInput {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.searchInput1 {
  display: flex;
  width: 70%;
  gap: 10px;
  justify-content: flex-start;
}

.containerModal3 {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
}

.containerModal2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.containerModal1 {
  height: 30vh;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-top: 20px;
}

.rowContainer span {
  font-weight: 600;
  font-size: 11px;
}

.rowContainer1 {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
}

.rowContainer1 span {
  font-weight: 600;
  font-size: 11px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.selectPlus {
  position: relative;
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.product-report-select {
  width: 100%;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9.5px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  width: 95%;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.containerRadioReceipt label {
  width: 100%;
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}

.containerRadioReceipt label input {
  position: absolute;
  left: -9999px;
}

.containerRadioReceipt label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadioReceipt label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #006256;
}

.containerRadioReceipt label span {
  width: 100%;
  background-color: #f3f2f2;
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
}

.containerRadioReceipt label span:hover {
  background-color: #e6e6e6;
}

.containerRadioReceipt label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #006256;
}

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #006256;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #006256;
}

.stock-report-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (min-width: 1300px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1300px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .title {
    font-size: 17px;
  }

  .cardItem {
    height: 35px;
    font-size: 11px;
  }
}

@media screen and (max-width: 700px) {
  .dashboard {
    width: 100%;
    margin-top: 55px;
  }

  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding-right: 5px;
    padding-left: 5px;
  }

  .cardItem {
    display: flex;
    width: 23%;
    height: 60px;
    border: 1px solid rgb(215, 215, 215);
    border-radius: 4px;
    text-align: center;
    font-size: 11px;
    padding: 3px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    letter-spacing: 0px;
  }

  .product-movement-grid {
    flex-direction: column;
  }

  .product-movement-grid .selectPlus {
    width: 100%;
  }
}
</style>
